import type { ReactNode } from 'react'
import { Emblem, type EmblemName } from './brand/Emblems'
import { WindowTabs, type Tab } from './WindowTabs'
import { cx } from './cx'
import { CloseButton } from './CloseButton'

type Props = {
  title: string
  emblem: EmblemName
  tabs?: Tab[]
  activeTab?: string
  onTab?: (id: string) => void
  onClose?: () => void
  closeLabel?: string
  /** The window's own action (e.g. «Продолжить» of the battle result), right of the head. */
  action?: ReactNode
  idBase?: string
  className?: string
  bodyClassName?: string
  children: ReactNode
}

/** Working window chrome: iron frame, wood, head line with title and tabs. */
export function GameWindow({ title, emblem, tabs, activeTab, onTab, onClose, closeLabel = 'Закрыть окно', action, idBase = 'win', className, bodyClassName, children }: Props) {
  const panelId = tabs && activeTab ? `${idBase}-panel-${activeTab}` : undefined
  return (
    <section className={cx('window iron wood', className)} aria-labelledby={`${idBase}-title`}>
      <header className={cx('window__head', Boolean(action) && 'window__head--action', onClose && 'window__head--closable')}>
        <h2 className="window__title" id={`${idBase}-title`}><Emblem name={emblem} />{title}</h2>
        {tabs && activeTab && onTab && <WindowTabs tabs={tabs} active={activeTab} onChange={onTab} idBase={idBase} />}
        {action && <span className="window__act">{action}</span>}
        {onClose && <CloseButton className="window__close" onClose={onClose} label={closeLabel} />}
      </header>
      <div
        className={cx('window__body', bodyClassName)}
        role={panelId ? 'tabpanel' : undefined}
        id={panelId}
        aria-labelledby={panelId ? `${idBase}-tab-${activeTab}` : undefined}
      >
        {children}
      </div>
    </section>
  )
}
